export default function LogoStrip() {
  const items = [
    "Highest market rates",
    "Rate match guarantee",
    "Sub-60s settlement",
    "24/7 human support",
    "Referral rewards",
    "OTC bulk desk",
  ];
  return (
    <section className="border-y border-slate-200 py-5 bg-slate-50" data-testid="logo-strip">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-wrap justify-center gap-x-8 gap-y-2 text-xs uppercase tracking-wider text-slate-600">
          {items.map((i) => (
            <span key={i} className="flex items-center gap-2">
              <span className="w-1 h-1 rounded-full bg-[#3B6FBF]" />
              {i}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
